module.exports = __webpack_public_path__ + "static/media/ObservationSocial.af4a7f43.jpg";